import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import PerfilAlumnoModal from "../../navigation/academy/perfilAlumnoModal";

export interface AccionesAlumnoProps {
	studentId: number;
	campusId: number;
	/** En tarjetas de teléfono los botones van a la izquierda; en tabla, pegados a la derecha. */
	alinear?: "inicio" | "fin";
}

/**
 * "Ver perfil" y "Finanzas" con las mismas pastillas del módulo Estudiantes (waAccionFila),
 * para que en Estudiantes por Aprobar y en Pagos por Procesar se vean y se usen igual
 * (Esteban, 2026-09-23). El clic no sube a la fila: la fila abre la solicitud o el ticket.
 */
const comoBoton: React.CSSProperties = { display: "inline-flex", alignItems: "center", justifyContent: "center", textDecoration: "none" };
const clicNormal = (e: React.MouseEvent) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

const AccionesAlumno: React.FC<AccionesAlumnoProps> = ({ studentId, campusId, alinear }) => {
	const navigate = useNavigate();
	//El perfil se abre en ventana, sin salir de la pantalla; Finanzas sí es otra pantalla, como en Estudiantes.
	const [viendo, setViendo] = useState<boolean>(false);
	/*
		Son enlaces de verdad (Caja MTY, 2026-10-03): clic derecho → "Abrir en pestaña nueva", o Ctrl/Cmd + clic, para
		aplicar el pago en Finanzas sin perder el ticket. El clic normal hace lo de siempre.
	*/
	const perfil = `/students?alumno=${studentId}&plantel=${campusId}`;
	const finanzas = `/statement?alumno=${studentId}&plantel=${campusId}`;
	return (
		<div className="waAcciones" style={alinear === "inicio" ? { justifyContent: "flex-start" } : undefined} onClick={(e) => e.stopPropagation()}>
			<a href={perfil} className="waAccionFila principal" style={comoBoton} onClick={(e) => { if (clicNormal(e)) { e.preventDefault(); setViendo(true); } }}>Ver Perfil</a>
			<a href={finanzas} className="waAccionFila" style={comoBoton} onClick={(e) => { if (clicNormal(e)) { e.preventDefault(); navigate(finanzas); } }}>Finanzas</a>
			{viendo ? <PerfilAlumnoModal studentId={studentId} campusId={campusId} onClose={() => setViendo(false)} /> : ""}
		</div>
	);
};

export default AccionesAlumno;
